export default {
  "volcanic_region": "Our Volcanic Region",
  "volcanic_region_description": "Discover what makes our coffees so special and how the volcanic region contributes to the development of unique and complex flavors.",
  "specialty_coffees": "Specialty Coffees",
  "specialty_coffees_description": "Our coffees are grown in volcanic soils rich in minerals, providing unique and complex flavors.",
  "sustainability": "Sustainability",
  "sustainability_description": "Sustainable farming practices that preserve the ecosystem and ensure product quality.",
  "volcanic_terroir": "Volcanic Terroir",
  "volcanic_terroir_description": "The unique geography of the volcanic region gives distinctive characteristics to our coffees.",
  "awarded": "Awarded",
  "awarded_description": "Our producers receive international recognition for exceptional quality.",
  "community": "Community",
  "community_description": "We support local communities and promote fair trade practices.",
  "global_presence": "Global Presence",
  "global_presence_description": "We export to more than 30 countries, bringing the unique taste of volcanic coffees to the world.",
  "learn_more": "Learn More About Our Region"
}
